export function linkGrids(master, detail, opts) {
    let cur, seq = 0, bypass = false, asking = false;
    const load = async (row, force = false) => {
        if (row < 0)
            return;
        const key = master.ds.get(row, opts.key);
        if (!force && key === cur)
            return;
        cur = key;
        const my = ++seq;
        detail.setLoading(true);
        try {
            const data = await opts.load(master.ds.getRow(row), key);
            if (my !== seq)
                return; // 더 새 요청이 있음
            detail.ds.loadColumnar(data);
            opts.onLoad?.(key, row);
        }
        catch (e) {
            if (my === seq) {
                cur = undefined;
                opts.onError?.(e, key);
            }
        }
        finally {
            if (my === seq)
                detail.setLoading(false);
        }
    };
    const offGuard = master.on('beforeRowFocus', e => {
        if (bypass || opts.confirmLeave === false || !detail.ds.hasChanges())
            return;
        if (asking)
            return false;
        asking = true;
        const col = master.getFocusedColumn();
        const buttons = [...(opts.save ? [{ id: 'save', label: '저장 후 이동', primary: true }] : []), { id: 'discard', label: '버리고 이동' }, { id: 'cancel', label: '취소' }];
        master.confirmDialog('저장하지 않은 변경', `아래 목록에 저장하지 않은 변경 ${countChanges()}건이 있습니다.`, buttons).then(async (a) => {
            try {
                if (a === 'save') {
                    if (!(await opts.save()))
                        return;
                }
                else if (a === 'discard')
                    detail.ds.revertAll();
                else {
                    master.focusGrid();
                    return;
                }
                bypass = true;
                try {
                    master.focusCell(e.row, col);
                }
                finally {
                    bypass = false;
                }
            }
            finally {
                asking = false;
            }
        });
        return false;
    });
    const countChanges = () => { const c = detail.ds.changeCounts(); return c.inserted + c.updated + c.deleted; };
    const offFocus = master.on('rowFocus', e => { load(e.row); });
    // 마스터를 (다시) 불러오면 포커스 행 기준으로
    const offDs = master.ds.on(e => { if (e.type === 'load' || e.type === 'merge')
        queueMicrotask(() => { const r = master.getFocusedRow(); if (r >= 0)
            load(r); }); });
    if (master.getFocusedRow() >= 0)
        load(master.getFocusedRow());
    return {
        dispose() { offGuard(); offFocus(); offDs(); },
        reload() { return load(master.getFocusedRow(), true); },
        currentKey: () => cur,
    };
}
